import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { GetSingleTvSeriesResponse } from "../../../../common/api/catalogue-api/tv-api/GetSingleTvSeriesResponse";
import { useCatalogueTvApi } from "../../../../common/api/catalogue-api/tv-api/useCatalogueTvApi";
import { useAssetListingConfig } from "../../common/config/useAssetListingConfig";
import { SingleTvSeriesContext } from "./SingleTvSeriesContext";
import { mapToTvSeriesCatalogueEntry, TvSeriesCatalogueEntry } from "./TvSeriesCatalogueEntry";

type SingleTvSeriesProviderProps = React.PropsWithChildren<unknown>;

export const SingleTvSeriesProvider: React.FunctionComponent<SingleTvSeriesProviderProps> = (
    props: SingleTvSeriesProviderProps
) => {
    const { tvSeriesId } = useParams<{ tvSeriesId: string }>();

    const { children } = props;

    const { getSingleTvSeries } = useCatalogueTvApi();

    const [tvSeries, setTvSeries] = useState<TvSeriesCatalogueEntry>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { listingConfig, saveListingConfig } = useAssetListingConfig();

    useEffect(() => {
        setIsLoading(true);

        getSingleTvSeries(tvSeriesId)
            .then((response: GetSingleTvSeriesResponse) => {
                const mappedResponse = mapToTvSeriesCatalogueEntry(response);

                setTvSeries(mappedResponse);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [tvSeriesId]);

    return (
        <SingleTvSeriesContext.Provider value={{ tvSeries, isLoading, listingConfig, saveListingConfig }}>
            {children}
        </SingleTvSeriesContext.Provider>
    );
};
